var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EMPTY_ID, isIdZeroLevel, createId, getRootParentId, getIdWithoutRootParentId, getAllParentsShortIds } from './itemIdUtils';
/**
 * @hidden
 */
export function isItemExpandedAndWithChildren(item, fieldsSvc) {
    return fieldsSvc.expanded(item) && hasChildren(item);
}
/**
 * @hidden
 */
export function resolveItemId(itemMatcher, items) {
    return resolveItemIdHelper(itemMatcher, items, EMPTY_ID);
}
/**
 * @hidden
 */
export function updateItem(items, itemId, update) {
    var result = [];
    for (var index = 0; index < items.length; index++) {
        if (Number(getRootParentId(itemId)) === index) {
            var item = __assign({}, items[index]);
            if (isIdZeroLevel(itemId)) {
                update(item);
            }
            else if (items[index].items) {
                item.items = updateItem(items[index].items, getIdWithoutRootParentId(itemId), update);
            }
            result.push(item);
        }
        else {
            result.push(items[index]);
        }
    }
    return result;
}
/**
 * @hidden
 */
export function hasChildren(item) {
    return Boolean(item.items && item.items.length);
}
/**
 * @hidden
 */
export function isEnabledAndAllParentsEnabled(itemId, items, fieldsSvc) {
    var ids = getAllParentsShortIds(itemId);
    var currentItems = items;
    for (var index = 0; index < ids.length; index++) {
        var currentItem = currentItems[Number(ids[index])];
        if (fieldsSvc.disabled(currentItem)) {
            return false;
        }
        else {
            currentItems = currentItem.items;
        }
    }
    return true;
}
function resolveItemIdHelper(itemMatcher, items, parentItemId) {
    var result = undefined;
    for (var index = 0; index < items.length; index++) {
        var element = items[index];
        if (itemMatcher(element)) {
            result = createId(index, parentItemId);
            break;
        }
        else if (hasChildren(element)) {
            result = resolveItemIdHelper(itemMatcher, element.items, createId(index, parentItemId));
            if (result) {
                break;
            }
        }
    }
    return result;
}
//# sourceMappingURL=itemUtils.js.map